import axios from "axios";
const jsonConfig = require("../../Config.json");

 const updateUserInterviewDetails = async (userId,jdId,payload) => {

    let allResponse = {}
    try {
        allResponse = await axios.put(`${jsonConfig.apiUrl}screeningsession/${jdId}`, 
            {
                userId,
                payload
            },            
            {
            headers: {
                "x-functions-key": jsonConfig.key,
            }
        });
        
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default updateUserInterviewDetails;